import React from 'react';
import './skeleton.scss';

function Skeleton({ type = '', style }: { type?: string, style?: any }) {
    return (
        <div className="skeleton-wrapper">
            <span className={`skeleton-image ${type}`} style={style}></span>
        </div>
    )
}

export default Skeleton;
